import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 10% 15% 7% 17%;
  color: ${({ theme }) => theme.color.textBlack};
  a {
    color: ${({ theme }) => theme.color.textRed};
  }

  @media (max-width: 768px) {
    padding: 8rem 10% 10%;
  }
`;
const Title = styled.div`
  ${({ theme }) => theme.typography.footerSubHeadline()}
  margin-bottom: 20px;
  @media screen and (max-width: ${({ theme }) => theme.device.mobileL}) {
    ${({ theme }) => theme.typography.titleBar()}
  }
`;

const SubTitle = styled.div`
  margin: 1.6em 0 1.6em;
  ${({ theme }) => theme.typography.link()};
  line-height: 27px;
  @media screen and (max-width: ${({ theme }) => theme.device.mobileL}) {
    ${({ theme }) => theme.typography.formHeadline()}
  }
`;
const Address = styled.div`
  ${({ theme }) => theme.typography.link()};
  line-height: 27px;
  white-space: pre-line;
  margin-top: 40px;
  @media screen and (max-width: ${({ theme }) => theme.device.mobileL}) {
    ${({ theme }) => theme.typography.formHeadline()}
  }
`;

const Director = styled.div`
  white-space: pre-line;
  ${({ theme }) => theme.typography.cardHover()};
  @media screen and (max-width: ${({ theme }) => theme.device.mobileL}) {
    ${({ theme }) => theme.typography.formHeadline()}
  }
`;

const TextLink = styled.div`
  ${({ theme }) => theme.typography.cardHover()};
  @media screen and (max-width: ${({ theme }) => theme.device.mobileL}) {
    ${({ theme }) => theme.typography.formHeadline()}
  }
`;

const ButtonLink = styled.a`
  ${({ theme }) => theme.typography.link()};
  color: ${({ theme }) => theme.color.textBlack};
  background-color: none;
  transition: color 0.1s;
  margin-left: 0.5rem;
`;

const ImprintWrapper = ({
  title,
  detail,
  address,
  director,
  textEmail,
  titleEmail,
  textWeb,
  titleWeb,
  staticEmail,
}) => {
  return (
    <Wrapper>
      <Title>{title}</Title>
      <SubTitle>{detail}</SubTitle>
      <Address>{address}</Address>
      <Director>{director}</Director>
      <TextLink>
        {textEmail}
        <ButtonLink href={`${titleEmail}`} rel="nofollow">
          {staticEmail}
        </ButtonLink>
      </TextLink>
      <TextLink>
        {textWeb}
        <ButtonLink href={titleWeb} target="_blank" rel="nofollow">
          {titleWeb}
        </ButtonLink>
      </TextLink>
    </Wrapper>
  );
};

export default ImprintWrapper;
